
export function updateInputState(fieldName, value) {
  this.setState((prevState) => ({
    input: {
      ...prevState.input,
      [fieldName]: value
    }
  }));
}

export function updateErrorState(fieldName, errorMessage) {
  this.setState((prevState) => ({
    errors: {
      ...prevState.errors,
      [fieldName]: errorMessage
    }
  }));
}

export function updateShowDevState(fieldName, isVisible) {
  this.setState((prevState) => ({
    showDev: {
      ...prevState.showDev,
      [fieldName]: isVisible
    }
  }));
}